import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Radio, Square } from 'lucide-react';
import { subscribeRecorder, stopRecording } from './recorder';
import { studioApi } from './studioApi';

// Always-mounted (in Layout) fixed bar shown ONLY while a Coach Studio recording
// is in progress, so the author can demonstrate a workflow across pages and stop
// from anywhere. On stop it saves the safe recording and returns to the Studio.
export default function StudioRecorderBar() {
  const [state, setState] = useState({ active: false, count: 0, goal: '' });
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  useEffect(() => subscribeRecorder(setState), []);

  if (!state.active) return null;

  const stop = async () => {
    setSaving(true);
    const rec = stopRecording();
    try {
      const saved = await studioApi.saveRecording(rec.goal, rec.steps);
      navigate(`/coach-studio?recording=${saved.recording_id}`);
    } catch (e) {
      navigate('/coach-studio');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="studio-recorder-bar"
      className="fixed top-3 left-1/2 -translate-x-1/2 z-[80] flex items-center gap-3 px-4 py-2 rounded-full bg-rose-600 text-white shadow-lg">
      <Radio className="w-4 h-4 animate-pulse" />
      <span className="text-xs font-medium">Recording demonstration · {state.count} step{state.count === 1 ? '' : 's'}</span>
      <button data-testid="studio-recorder-stop" onClick={stop} disabled={saving}
        className="ml-1 inline-flex items-center gap-1 text-xs font-semibold bg-white/20 hover:bg-white/30 rounded-full px-2.5 py-1">
        <Square className="w-3 h-3" /> {saving ? 'Saving…' : 'Stop'}
      </button>
    </div>
  );
}
